import { useMemo } from 'react'
import { Icon } from '@iqueue/ui-kit'
import ForbiddenError from './ForbiddenError'
import UnauthorizedError from './UnauthorizedError'
import NetworkError from './NetworkError'
import NotFoundError from './NotFoundError'
import cn from 'classnames'

function UnknownError({ error, className }) {
  return <div className={ cn('iq-error-view center', className) }>
    <h1><Icon>sentiment_dissatisfied</Icon></h1>
    <h4>Непредвиденная ошибка!</h4>
    <p>Пожалуйста, сообщите ее разработчику</p>
    <p>Ошибка: { error.message }</p>
  </div>
}

export default function ErrorView({ error, refetch, className }) {
  const View = useMemo(() => {
    switch (error.status) {
      case 403:
        return ForbiddenError
      case 401:
        return UnauthorizedError
      case 404:
        return NotFoundError
      case 500:
        return NetworkError
      default:
        return UnknownError
    }
  }, [error])

  return <View
    className={ className }
    error={ error }
    refetch={ refetch }
  />
}
